import React, { useState, useEffect } from 'react'
import { LayoutPage, LayoutPageHeaderStyle, Loader } from '@wallyhealth/web-core'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import classes from 'classnames'
import ExpressPayOption from './ExpressPayOption'
import styles from './index.module.css'
import CardPayOption from './CardPayOption'
import config from 'config'
import intelService from 'services/intelService'
import adsFacade from 'facades/adsFacade'

const DEFAULT_TITLE = 'One last step, payment.'
const DEFAULT_DESCRIPTION = 'Once you join your care team will text you how to book your first appointment. And if you change your mind before your first visit, we’ll refund you 100%.'

const PaymentPage = ({ customer, totalCostInCents, planType, prepSubscription, viewName, onBack, title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION }) => {
  const [isStripeInitializing, setIsStripeInitializing] = useState(true)

  useEffect(() => {
    intelService.recordView({ viewName })
  }, [])

  const recordPaymentClick = async ({ clickName }) => {
    const { eventId } = await intelService.recordClick({
      clickName,
      viewName,
      identity: customer
    })
    adsFacade.recordPurchaseEvent({ eventId, planType })
  }

  const onStripeInit = () => {
    setIsStripeInitializing(false)
  }

  return (
    <LayoutPage
      headerStyle={LayoutPageHeaderStyle.FULL}
      title={title}
      description={description}
      onBack={onBack}>

      <div className={styles.body}>

        {isStripeInitializing &&
          <Loader
            className={styles.loader}
            label="Loading payment options"
          />
        }

        <div
          className={classes({
            [styles.buttons_loading]: isStripeInitializing,
            [styles.buttons_loaded]: !isStripeInitializing
          })}>
          <CardPayOption
            totalCostInCents={totalCostInCents}
            recordPaymentClick={recordPaymentClick}
            prepSubscription={prepSubscription}
            buttonClassName={styles.card_button}
          />
          <ExpressPayOption
            totalCostInCents={totalCostInCents}
            planType={planType}
            recordPaymentClick={recordPaymentClick}
            prepSubscription={prepSubscription}
            onInit={onStripeInit}
            className={styles.express}
          />
        </div>

      </div>
    </LayoutPage>
  )
}

const stripePromise = loadStripe(config.STRIPE_PUBLISHABLE_KEY)

const StripeEnabledPaymentPage = (props) => (
  <Elements
    stripe={stripePromise}
    options={{
      mode: 'subscription',
      amount: props.totalCostInCents,
      currency: 'usd',
      setupFutureUsage: 'off_session',
      paymentMethodCreation: 'manual',
      appearance: {
        variables: {
          borderRadius: '0.3em'
        }
      }
    }}>
    <PaymentPage {...props} />
  </Elements>
)

export default StripeEnabledPaymentPage
